module.exports = __webpack_public_path__ + "static/media/IMG_8862.12c8bce4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/horizontal/IMG_8862.jpg
// module id = 157
// module chunks = 0